'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SsoKeycloakLandingCtrl', SsoKeycloakLandingCtrl);

  SsoKeycloakLandingCtrl.$inject = ['$state', '$rootScope', '$log'];

  function SsoKeycloakLandingCtrl($state, $rootScope, $log) {
    var vm = this;

    var keycloakInstanceURL = $rootScope.keyCloakConfiguration.host;
    var keycloakRealm = $rootScope.keyCloakConfiguration.realm;
    var keycloakClient = $rootScope.keyCloakConfiguration.client;
    var redirectURI = location.origin + '/login/sso/keycloak';

    vm.loginWithSSOLink = keycloakInstanceURL + '/auth/realms/' + keycloakRealm + '/protocol/openid-connect/auth?' + 'client_id=' + keycloakClient + '&kc_idp_hint=oidc' + '&redirect_uri=' + redirectURI + '&response_mode=fragment' + '&response_type=code' + '&scope=openid';

    // SSO
    var Keycloak = null;
    if (window && window.Keycloak) {
      Keycloak = window.Keycloak;
    }

    var keycloak = new Keycloak({
      url: "https://keycloak.mystrength.integration.teladoc.io/auth",
      realm: "myStrIBroker",
      clientId: "myStrIntlWell",
      onLoad: 'check-sso'
    });

    _init();

    function _init() {
      keycloak.init({
        checkLoginIframe: true,
        onLoad: 'check-sso',
        redirectUri: location.origin + '/login/sso/keycloak'
      }).success(function (auth) {

        if (auth) {
          $state.go('sso.customData', { keycloakToken: keycloak.token });
        } else {
          $log.info('Not Authenticated');
        }
      });
    }
  }
})();